export const CustomerModule = {
    namespaced: true,
    state: {
        customerList: [],
        tableLoader: 1,
        totalRecord: 0,
        totalLenght: 0,
    }
}